export const noop = (): void => {};

export function isDefined<T>(value: T): value is Exclude<T, undefined> {
    return typeof value !== 'undefined';
}

export const keyBy = (array: string[], key?: number) =>
    (array || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {});

export const keyCodes = {
    SPACE: 32,
    ENTER: 13,
    ESC: 27,
    DOWN_ARROW: 40,
    UP_ARROW: 38,
    SHIFT: 16,
    TAB: 9,
};

export const keys = {
    TAB: 'Tab',
    ESC: 'Escape',
    RIGHT_ARROW: 'ArrowRight',
    LEFT_ARROW: 'ArrowLeft',
    ENTER: 'Enter',
    NUM_ENTER: 'NumpadEnter',
    UP_ARROW: 'ArrowUp',
    DOWN_ARROW: 'ArrowDown',
    SPACE: 'Space',
};
